import { Component } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';

@Component({
  selector: 'lgb-shop',
  imports: [
    UiModule
  ],
  templateUrl: './shop.html',
  styleUrl: './shop.css',
})
export class Shop {

}
